import cloneDeep from "lodash/cloneDeep";

import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";

class CommonHelper {
    public static GetEmployeesBasedOnSite(allEmployees: Immutable.List<Person>, allSites: SiteUIModel[], selectedSiteId: Guid): Immutable.List<Person> {
        var cliniciansFromSite: Immutable.List<Person> = Immutable.List([]);
        var selectedSite = ArrayHelper.Find(allSites, x => x.Id == selectedSiteId);

        if (selectedSite != null) {
            var filtered = allEmployees.toArray().filter((c: Person) => c.EmployeeModel.AssociatedSites.contains(selectedSiteId));
            cliniciansFromSite = Immutable.List(filtered);
        }

        return cliniciansFromSite;
    }

    /**
     * return boolean whether all elements in personArrayA exist in personArrayB
     * @param {Person[]} personArrayA
     * @param {Person[]} personArrayB
     * @returns {boolean}
     */
    public static hasAllPerson(personArrayA: Person[], personArrayB: Person[]): boolean {
        if (!personArrayA || !personArrayB) {
            return false;
        }
        else {
            return personArrayA.every(pa => personArrayB.any(pb => pa.ContactFacetId === pb.ContactFacetId));
        }
    }

    /**
     * Check if given two arrays of DOMRect are not equal
     * @param {DOMRect[]} a
     * @param {DOMRect[]} b
     * @returns {boolean}
     */
    public static isDOMRectArraysNotEqual(a: DOMRect[], b: DOMRect[]): boolean {
        if (!a || !b) {
            return false;
        }

        if (a?.length === b?.length) {
            for (let i = 0; i < a.length; i++) {
                for (const key in a[i]) {
                    if (a[i][key] !== b[i][key]) {
                        return true;
                    }
                }
            }

            return false;
        }
        else {
            return true;
        }
    }

    /**
     * Return deep clone by lodash
     * @param {any} a
     * @returns {any} deep clone
     */
    public static getCloneDeep(a: any): any {
        return cloneDeep(a);
    }
}

export { CommonHelper };
